$(document).ready(function () {
    $(document).on("click", ".styledCheckboxWrapper", function () {
        $(this).find(".styledCheckbox:not(.disabled)").trigger("click");
        $(this).find(".zbr-checkbox[data-type='styledCheckbox']:not(.disabled)").trigger("click");
    });
    $(document).on("click", ".zbr-checkbox[data-type='styledCheckbox']:not(.disabled)", function (e) {
        e.stopPropagation();
        checkboxclickevent($(this), true);
        return false;
    });

    $(document).on("click", ".styledCheckbox:not(.disabled)", function (e) {
        e.stopPropagation();
        checkboxclickevent($(this), true);
        return false;
    });

    $(document).on("clickwithtrigger", ".zbr-checkbox[data-type='styledCheckbox']:not(.disabled)", function (e) {
        e.stopPropagation();
        checkboxclickevent($(this), true);
        return false;
    });
    $(document).on("clickwithouttrigger", ".zbr-checkbox[data-type='styledCheckbox']:not(.disabled)", function (e) {
        e.stopPropagation();
        checkboxclickevent($(this), false);
        return false;
    });

    $(document).on("clickwithtrigger", ".styledCheckbox:not(.disabled)", function (e) {
        e.stopPropagation();
        checkboxclickevent($(this), true);
        return false;
    });
    $(document).on("clickwithouttrigger", ".styledCheckbox:not(.disabled)", function (e) {
        e.stopPropagation();
        checkboxclickevent($(this), false);
        return false;
    });
});

var checkboxclickevent = function ($this, firetrigger) {
    $this.toggleClass("selected");
    if ($this.hasClass("zbr-checkbox")) {
        $this.toggleClass("zbr-checkbox--checked");
        if ($this.hasClass("zbr-checkbox--checked")) {
            $this.addClass("selected");
        } else {
            $this.removeClass("selected");
        }
    }

    var $input = $this.next();
    $input.attr("disabled", !$this.hasClass("selected"));

    if (firetrigger){
        $.event.trigger("styledCheckboxChanged", [$input.attr("name"), $input.val(), $input.attr("disabled") == undefined, $this]); // Name, value, isSelected, jqueryelement
    }
};
